import { types } from "../../types/types";

const initialState = {
    credenciales: null,
    loading: false,
    dataAfiliado:null,
    loadingDataAfiliado:false
};

export const AfiliadoVariosReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.traerCredencialesStart:
            return {
                ...state,
                loading: true
            }
        case types.traerCredencialesSuccess:
            return {
                ...state,
                credenciales: action.payload,
                loading: false
            }
        case types.traerCredencialesError:
            return {
                ...state,
                credenciales: [],
                loading: false
            }
            case types.traerDataPersonalStart:
            return {
                ...state,
                loading: true
            }
        case types.traerDataPersonalSuccess:
            return {
                ...state,
                dataAfiliado: action.payload,
                loading: false
            }
        case types.traerDataPersonalError:
            return {
                ...state,
                dataAfiliado: null,
                loading: false
            }
        default:
            return state;
    }
};
